import { render, staticRenderFns } from "./UserDataPassword.vue?vue&type=template&id=43594cfa&scoped=true&"
import script from "./UserDataPassword.vue?vue&type=script&lang=js&"
export * from "./UserDataPassword.vue?vue&type=script&lang=js&"
import style0 from "./UserDataPassword.vue?vue&type=style&index=0&id=43594cfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43594cfa",
  null
  
)

export default component.exports